const API = "/api";
const KAKAO_BASE_URL = `https://dapi.kakao.com/v2/local`;

const api = {
  api: API,
  kakao: KAKAO_BASE_URL
};

export default api;
